/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Search_DescriptionInputs */

const en_directory_tools_search_description = /** @type {(inputs: Directory_Tools_Search_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find tools by keyword, category, or use case.`)
};

const zh_directory_tools_search_description = /** @type {(inputs: Directory_Tools_Search_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按关键词、分类或使用场景查找工具。`)
};

/**
* | output |
* | --- |
* | "Find tools by keyword, category, or use case." |
*
* @param {Directory_Tools_Search_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_search_description = /** @type {((inputs?: Directory_Tools_Search_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Search_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_search_description(inputs)
	return zh_directory_tools_search_description(inputs)
});
export { directory_tools_search_description as "directory.tools.search.description" }